<template>
  <Logo
    height="14"
    alt="Ayrow"
  />
</template>

<script>
export default {
  name: 'ExternalLinkBaserowLogo',
}
</script>
